import { Component, OnInit, Inject } from '@angular/core';


import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UserService } from '../../../services/user/user.service';
import { LocalStorage } from '@ngx-pwa/local-storage';


import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { PeersService } from '../../../services/peers/peers.service';


import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../../toast/toast.component';



export interface DialogData {
    id: any;
    msg: any;
}


@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private snackBar: MatSnackBar,
    ) { }

    ngOnInit() {
    }


    onNoClick(): void {
        this.dialogRef.close({
            id: this.data.id, 
            confirm: false
        });
    }

    confirm(): void{
        this.dialogRef.close({
            id: this.data.id, 
            confirm: true
        });
    }

}
